import styled from 'styled-components';

export const TooltipContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  min-width: 150px;
  color: #1a1a1a;
  font-size: 14px;
  background-clip: padding-box;
`;

export const MetricRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const MetricLabel = styled.span`
  color: #666;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
`;

export const MetricValue = styled.span`
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
`;
